import React from "react";
import { useParams } from "react-router-dom";
import TitleUpdater from "../components/common/layout/TitleUpdater";
import DebugFP from "../components/common/internal/DebugFP";

export default function DebugOrderPage() {
  const { indexId } = useParams();
  const indexValue = indexId || "0";

  return (
    <div>
      <TitleUpdater />
      <DebugFP index={indexValue} />
    </div>
  );
}
